import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";

import { useAppSelector } from "@/redux/hooks";

import { featureUsageApi } from "./feature-usage.api";

import type {
	ProductUsageFilters,
	ProductUsagePeriod,
	ProductUsageAllCustomersPeriod,
} from "@signalist/shared-types";

// The already-registered API slice owns a bucket for every argument. Subscribe separately and
// read that exact bucket through Redux: no previous company's data during a switch or cache hit.
export function useUsageAdoption(filters: ProductUsageFilters) {
	const endpoint = featureUsageApi.endpoints.getFeatureUsageAdoption;
	const { refetch } = endpoint.useQuerySubscription(filters);

	return {
		...useAppSelector(useMemo(() => endpoint.select(filters), [endpoint, filters])),
		refetch,
	};
}
export function useUsageUnused(filters: ProductUsageFilters) {
	const endpoint = featureUsageApi.endpoints.getFeatureUsageUnused;
	const { refetch } = endpoint.useQuerySubscription(filters);

	return {
		...useAppSelector(useMemo(() => endpoint.select(filters), [endpoint, filters])),
		refetch,
	};
}
export function useUsageCompanies() {
	const endpoint = featureUsageApi.endpoints.getFeatureUsageCompanies;
	const { refetch } = endpoint.useQuerySubscription();

	return { ...useAppSelector(useMemo(() => endpoint.select(), [endpoint])), refetch };
}
export function useUsageCompany(companyId: number | null, period: ProductUsagePeriod) {
	const endpoint = featureUsageApi.endpoints.getFeatureUsageCompany;
	const args = useMemo(
		() => (companyId === null ? skipToken : { companyId, period }),
		[companyId, period]
	);
	const { refetch } = endpoint.useQuerySubscription(args);

	return { ...useAppSelector(useMemo(() => endpoint.select(args), [endpoint, args])), refetch };
}
export function useUsageAllCustomers(period: ProductUsageAllCustomersPeriod) {
	const endpoint = featureUsageApi.endpoints.getFeatureUsageAllCustomers;
	const { refetch } = endpoint.useQuerySubscription(period);

	return { ...useAppSelector(useMemo(() => endpoint.select(period), [endpoint, period])), refetch };
}
